import React, { useEffect, useState } from "react";
import "./DboardHeader.css";
import profile_picture from "../../images/profile_picture.svg";
import default_pfp from "../../images/default_pfp.svg";
import down_arrow from "../../images/down_arrow_admin.svg";
import { useNavigate, Link } from "react-router-dom";
import { CommunityOwner, SuperAdmin } from "../../Utils/Constant";
import { useDispatch, useSelector  } from "react-redux";
import { fetchProfileData } from "../../Services/Profile/ProfileApi";
import { setHeaderMessage } from "../../Services/DashboardHeader/uiSlice";
import { useLocation } from 'react-router-dom';

function DashboardHeader({isCollapsed}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const userId = localStorage.getItem("user_id");
  const userType = localStorage.getItem("user_type");
  const firstName = localStorage.getItem("user_first_name");
  const lastName = localStorage.getItem("user_last_name");
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState({});


  //for fixed chatbot header




  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("user_id");
    localStorage.removeItem("user_type");
    localStorage.removeItem("user_first_name");
    localStorage.removeItem("user_last_name");
    localStorage.removeItem("access_token");
    localStorage.removeItem("email");
    localStorage.removeItem("password");
   
  };
  const { data } = useSelector((state) => state.fetchProfileData);
  const headerMessage = useSelector((state) => state.ui.headerMessage);
  

  useEffect(() => {

    if (location.pathname === "/user/chatboat") {
      dispatch(setHeaderMessage(
        <>

          <img src="https://cdn-icons-png.flaticon.com/128/7933/7933542.png" 
               alt="Bot Icon" width="40" style={{ marginRight: 6 }} />
          ITAF CLINICAL ASSISTANT
        </>
      ));
    } else if (location.pathname === '/user/admin-profile') {
      dispatch(setHeaderMessage("My Profile"));
    } else if (location.pathname === '/user/update-user'){
      
      dispatch(setHeaderMessage("Update User"));
    }else if (location.pathname === '/user/user-profile'){
      dispatch(setHeaderMessage("Profile"));
    }else if (location.pathname === '/user/privacy-policy'){
      dispatch(setHeaderMessage("AI Privacy & Content Use Statement")); 
    }
    else{
      dispatch(setHeaderMessage("Change Password"));
    }


    dispatch(fetchProfileData(userId)).finally(() => setLoading(false));
  }, [location.pathname,dispatch]);

  useEffect(() => {
    if (data) {
      setProfile(data.user_details);
    }
  }, [data]);

  const isFixed = location.pathname === "/user/chatboat";

  return (
    <>
    <div className={`header-main ${!isCollapsed ? "fixed-header" : "not-fixed-header"}`}>
        <div className="header-inner-main d-flex justify-content-between align-items-center">
          {/* <div className="dashboard-title">Community Management</div> */}
          <div className="dashboard-title">
             {headerMessage} 
             <p className="m-0" style={{ fontStyle: "italic", fontWeight: 600, fontSize: "14px" }}>
  Creating customizable solutions for overall wellness
</p>

          </div>
          <div className="d-flex flex-column align-items-end">
            <div class="dropdown">
              <div
                class="dropdown-toggle d-flex align-items-center admin-profile-dropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div className="profile-picture-admin">
                  <img
                    src={profile?.image || default_pfp}
                    alt="Profile-picture"
                    onError={(e) => {
                      e.target.onerror = null; // Prevent infinite loop
                      e.target.src = default_pfp; // Fallback image
                    }}
                  />
                </div>

                <div className="admin-name-div">
                  {firstName + " " + lastName}
                  <span>
                    {userType === CommunityOwner
                      ? "User"
                      : userType === SuperAdmin
                      ? "Super Admin"
                      : "Homeowner"}
                  </span>
                </div>
                <div className="down-arrow-block">
                  <img src={down_arrow} alt="down-arrow"></img>
                </div>
              </div>
              <ul class="dropdown-menu">
                <li>
                  <Link
                    to={
                      userType === CommunityOwner
                        ? "/user/user-profile"
                        : userType === SuperAdmin
                        ? "/super-admin/super-admin-profile"
                        : "/home-owner-admin/homeowner-profile"
                    }
                    onClick={() => dispatch(setHeaderMessage("Profile"))}
                    class="dropdown-item"
                  >
                    View Profile
                  </Link>
                </li>
                {/* <li>
                  <a class="dropdown-item" href="#">
                    Another action
                  </a>
                </li> */}
                <li>
                  <Link class="dropdown-item" onClick={handleLogout} to="/">
                    Logout
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    to="/user/change-password"
                    aria-current="page"
                  >
                    Change Password
                  </Link>
                </li>
              </ul>
            </div>
            {/* <p className="m-0 text-end">Creating customizable solutions for overall wellness</p> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default DashboardHeader;
